require('./_set-species')('Array');



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-polyfill/~/core-js/modules/es6.array.species.js
 ** module id = 220
 ** module chunks = 2 4 5 7
 **/